"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NotationComponent = void 0;
var _SvgIcon = _interopRequireDefault(require("../../SvgIcon/index.js"));
var _themeProvider = require("../../../../theme/themeProvider/index.js");
var _images = require("../../../../assets/images.js");
var _jsxRuntime = require("react/jsx-runtime");
const NotationComponent = (onNumberIncrease, isHover, onNumberDecrease, deltaIcon) => {
  const upIcon = deltaIcon == true ? _images.plusSign : _images.chevUp;
  const downIcon = deltaIcon == true ? _images.minusSign : _images.chevDown;
  const theme = (0, _themeProvider.useTheme)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      onClick: onNumberIncrease,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SvgIcon.default, {
        className: "standardinput__lefticon-style",
        url: upIcon,
        fillColor: theme.color.neutral300,
        fillHoverColor: theme.color.primary200,
        isHover: isHover
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      onClick: onNumberDecrease,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SvgIcon.default, {
        className: "standardinput__lefticon-style",
        url: downIcon,
        fillColor: theme.color.neutral300,
        fillHoverColor: theme.color.primary200,
        isHover: isHover
      })
    })]
  });
};
exports.NotationComponent = NotationComponent;
var _default = exports.default = NotationComponent;